export default {
  title: {
    cashManagement: 'Cash Management',
    pointsManagement: 'Points Management',
    rechargeRecord: 'Recharge Record'
  },
  menu: {
    cashManagement: 'Cash Management',
    pointsManagement: 'Points Management'
  },
  label: {
    companyName: 'Company',
    referralExpireDate: 'Referral Expire Date',
    balance: 'Balance',
    cashRechargeListTitle: '{companyName} Cash Recharge Record',
    pointsRechargeListTitle: '{companyName} Points Recharge Record',
    purchaseDate: 'Purchase Date',
    jobName: 'Job',
    activity: 'Activity',
    cash: 'Cash',
    note: 'Note',
    rechargeTitle: 'Recharge',
    companyCashBalanceTitle: 'Cash Balance of {companyName}: {balance}',
    companyPointsBalanceTitle: 'Points Balance of {companyName}: {balance}',
    rechargePoints: 'Point',
    rechargeNotes: 'Note'
  },
  btn: {
    recharge: 'Recharge',
    viewRechargeRecord: 'View Recharge Record'
  },
  placeholder: {
    searchCompany: 'Search for a company by title',
    rechargePoints: 'add or substract point',
    rechargeNotes: 'leave a note (optional)'
  },
  message: {
    rechargeNotice: 'Point can not be more than current balance when symbol is minus!',
    rechargeSuccess: 'Recharge Successfully!',
    rechargeFail: 'Recharge Failed!'
  },
  COMPANY_BALANCE_ACTIVITY: {
    PURCHASED: 'Purchased',
    ALLOCATED: 'Allocated',
    POST_PAY: 'PostPay',
    REFUND: 'Refund',
    REDISTRIBUTION: 'Internal transfer'
  }
}
